<template>
  <div class="pc-container">
    <!-- ===== 顶部导航 ===== -->
    <el-header class="header">
      <div class="header-left">
        <el-input
          v-model="searchKeyword"
          placeholder="请输入商品名称"
          size="medium"
          clearable
          @clear="clearSearch"
          @keyup.enter.native="handleSearch"
          class="search-input"
        />
        <el-button type="primary" size="medium" @click="handleSearch" style="margin-left: 0.5rem;">搜索</el-button>
      </div>
      <div class="header-right">
        <el-button type="success" size="medium" @click="openBatchDialog" :disabled="selectedGoodsIds.length === 0">
          <i class="el-icon-plus"></i> 批量绑定分类 ({{ selectedGoodsIds.length }})
        </el-button>
        <!-- 分类筛选（可选） -->
        <el-select
          v-model="filterCateId"
          placeholder="筛选分类"
          size="medium"
          clearable
          @change="handleFilterCate"
          style="width: 150px; margin-left: 10px;"
        >
          <el-option
            v-for="item in allCateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </el-header>

    <!-- ===== 商品表格 ===== -->
    <el-main>
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="!goodsList || goodsList.length === 0" class="empty-state">
        <i class="el-icon-document" style="font-size: 60px; color: #ccc;"></i>
        <p>暂无商品数据</p>
      </div>
      <el-table
        v-else
        ref="table"
        :data="goodsList"
        border
        stripe
        height="70vh"
        style="width: 97%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="comlist_v1" label="商品名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="图片" width="80" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.comlist_v8"
              :src="scope.row.comlist_v8"
              fit="cover"
              :preview-src-list="[scope.row.comlist_v8]"
              style="width: 50px; height: 50px; border-radius: 4px;"
            />
            <i v-else class="el-icon-picture-outline" style="font-size: 32px; color: #ccc;"></i>
          </template>
        </el-table-column>
        <el-table-column label="分类标签" min-width="200">
          <template slot-scope="scope">
            <el-tag
              v-for="(tag, index) in scope.row.cate_goods"
              :key="index"
              size="small"
              style="margin: 2px 4px;"
              type="info"
            >
              {{ tag.name }}
            </el-tag>
            <span v-if="!scope.row.cate_goods || scope.row.cate_goods.length === 0" style="color: #999;">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column prop="comlist3" label="创建时间" width="180" />
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click.stop="openEditCate(scope.row.id)">编辑分类</el-button>
            <el-button size="mini" type="danger" @click.stop="deleteGoods(scope.row)">解除绑定</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-if="totalPages > 0"
        background
        layout="total, prev, pager, next"
        :total="totalPages * pageSize"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchGoodsList"
        style="margin-top: 16px; text-align: right;width:98%;background-color: #fff;"
      />
    </el-main>

    <!-- ===== 批量绑定分类弹窗 ===== -->
    <el-dialog title="批量绑定分类" :visible.sync="batchDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="选择分类">
          <el-select v-model="batchFenleiId" placeholder="请选择分类" style="width: 100%;">
            <el-option
              v-for="item in allCateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="排序值">
          <el-input-number
            v-model="batchSort"
            :min="0"
            :step="1"
            size="small"
            style="width: 150px;"
          />
          <span style="color: #999; font-size: 12px; margin-left: 8px;">数值越大，优先级越高</span>
        </el-form-item>
        <p style="color: #999; font-size: 13px; margin-top: 8px;">
          将为选中的 <strong>{{ selectedGoodsIds.length }}</strong> 个商品绑定该分类
        </p>
      </el-form>
      <span slot="footer">
        <el-button @click="batchDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmBatchBind" :loading="batchLoading">确认绑定</el-button>
      </span>
    </el-dialog>

    <!-- ===== 编辑单个商品分类弹窗 ===== -->
    <el-dialog
      :title="'编辑分类 - ' + editGoodsName"
      :visible.sync="editDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="closeEditCate"
    >
      <div>
        <div style="margin-bottom: 16px; display: flex; align-items: center;">
          <el-select v-model="editSelectedFenleiId" placeholder="选择要添加的分类" style="width: 200px;">
            <el-option
              v-for="item in allCateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-input-number
            v-model="editSort"
            :min="0"
            :step="1"
            size="small"
            style="width: 120px; margin-left: 10px;"
            placeholder="排序值"
          />
          <span style="color: #999; font-size: 12px; margin-left: 6px;">(越大越优先)</span>
          <el-button type="primary" size="small" @click="addCateToGoods" :loading="addLoading" style="margin-left: 10px;">添加</el-button>
        </div>
        <el-table :data="editGoodsCateList" border stripe size="small">
          <el-table-column prop="fenlei_name" label="分类名称" />
          <el-table-column prop="create_time" label="绑定时间" width="180" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click.stop="removeCateFromGoods(scope.row.id)">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="editGoodsCateList.length === 0" style="color: #999; text-align: center; padding: 20px 0;">暂无绑定分类</p>
      </div>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'GoodsLibrary',
  data () {
    return {
      // 搜索
      searchKeyword: '',
      // 列表数据
      goodsList: [],
      loading: false,
      currentPage: 1,
      pageSize: 20,
      totalPages: 0,
      // 多选
      selectedGoodsIds: [],
      // 分类数据（来自接口20）
      allCateList: [], // [{id, name}]
      filterCateId: null, // 分类筛选
      // 批量绑定
      batchDialogVisible: false,
      batchFenleiId: null,
      batchSort: 0, // 新增：批量绑定的排序值
      batchLoading: false,
      // 编辑单个商品分类
      editDialogVisible: false,
      editGoodsId: null,
      editGoodsName: '',
      editGoodsCateList: [], // 该商品已绑定的分类记录（含id）
      editSelectedFenleiId: null,
      editSort: 0, // 新增：单个添加的排序值
      addLoading: false
    }
  },
  mounted () {
    this.fetchAllCate().then(() => {
      this.fetchGoodsList()
    })
  },
  methods: {

    // 1. 获取所有分类（接口20）

    async fetchAllCate () {
      try {
        const res = await request.post('/rcadmin/homeCate.php?a=select', {
          page: 1,
          page_size: 100
        })
        if (res && res.code === '0' && Array.isArray(res.res)) {
          this.allCateList = res.res.map(item => ({
            id: item.id,
            name: item.name
          }))
        } else {
          this.allCateList = []
        }
      } catch (error) {
        console.error('获取分类列表失败', error)
        this.allCateList = []
      }
    },

    // 2. 获取商品列表（接口23）

    async fetchGoodsList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.searchKeyword.trim()) {
          params.comlist_v1 = this.searchKeyword.trim()
        }
        if (this.filterCateId) {
          const cateRes = await request.post('/rcadmin/homeCateGoods.php?a=select', {
            fenlei_id: this.filterCateId,
            page: this.currentPage,
            page_size: this.pageSize
          })
          if (cateRes && cateRes.code === '0' && Array.isArray(cateRes.res)) {
            const goodsMap = new Map()
            cateRes.res.forEach(item => {
              if (!goodsMap.has(item.goods_id)) {
                goodsMap.set(item.goods_id, {
                  id: item.goods_id,
                  comlist_v1: item.comlist_v1,
                  comlist_v8: item.comlist_v8,
                  comlist3: item.create_time,
                  cate_goods: [item.fenlei_name]
                })
              } else {
                const existing = goodsMap.get(item.goods_id)
                existing.cate_goods.push(item.fenlei_name)
              }
            })
            this.goodsList = Array.from(goodsMap.values())
            this.totalPages = Math.ceil(cateRes.res.length / this.pageSize) || 1
          } else {
            this.goodsList = []
            this.totalPages = 0
          }
        } else {
          const res = await request.post('/rcadmin/homeCateGoods.php?a=goodsList', params)
          if (res && res.code === '0' && Array.isArray(res.res)) {
            this.goodsList = res.res
            this.totalPages = parseInt(res.pages) || 1
          } else {
            this.goodsList = []
            this.totalPages = 0
          }
        }
      } catch (error) {
        console.error('获取商品列表失败', error)
        this.goodsList = []
        this.totalPages = 0
      } finally {
        this.loading = false
      }
    },

    // 3. 搜索

    handleSearch () {
      this.currentPage = 1
      this.fetchGoodsList()
    },
    clearSearch () {
      this.searchKeyword = ''
      this.handleSearch()
    },

    // 4. 分类筛选

    handleFilterCate () {
      this.currentPage = 1
      this.fetchGoodsList()
    },

    // 5. 多选

    handleSelectionChange (selection) {
      this.selectedGoodsIds = selection.map(item => item.id)
    },

    // 6. 批量绑定分类（接口24）

    openBatchDialog () {
      if (this.selectedGoodsIds.length === 0) {
        this.$message.warning('请先选择商品')
        return
      }
      this.batchDialogVisible = true
      this.batchFenleiId = null
      this.batchSort = 0 // 重置
    },
    async confirmBatchBind () {
      if (!this.batchFenleiId) {
        this.$message.warning('请选择分类')
        return
      }
      this.batchLoading = true
      try {
        const idsStr = this.selectedGoodsIds.join(',')
        const params = {
          goods_ids: idsStr,
          fenlei_id: this.batchFenleiId,
          sort: this.batchSort || 1
        }
        // if (this.batchSort !== null && this.batchSort !== undefined && this.batchSort !== '') {
        //   params.sort = this.batchSort
        // }
        const res = await request.post('/rcadmin/homeCateGoods.php?a=add', params)
        if (res && res.code === '0') {
          this.$message.success(res.msg || '批量绑定成功')
          this.batchDialogVisible = false
          this.fetchGoodsList()
          this.$refs.table && this.$refs.table.clearSelection()
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      } catch (error) {
        console.error('批量绑定失败', error)
        this.$message.error('绑定失败')
      } finally {
        this.batchLoading = false
      }
    },

    // 7. 编辑单个商品分类（接口26/24/28）

    async openEditCate (goodsId) {
      this.editDialogVisible = true
      this.editGoodsId = goodsId
      this.editGoodsName = ''
      this.editSort = 0 // 重置
      const goods = this.goodsList.find(item => item.id === goodsId)
      if (goods) {
        this.editGoodsName = goods.comlist_v1 || '未命名'
      }
      await this.loadGoodsCate(goodsId)
    },
    async loadGoodsCate (goodsId) {
      try {
        const res = await request.post('/rcadmin/homeCateGoods.php?a=select', {
          goods_id: goodsId
        })
        if (res && res.code === '0' && Array.isArray(res.res)) {
          this.editGoodsCateList = res.res
        } else {
          this.editGoodsCateList = []
        }
      } catch (error) {
        console.error('加载商品分类失败', error)
        this.editGoodsCateList = []
      }
    },
    closeEditCate () {
      this.editDialogVisible = false
      this.editGoodsId = null
      this.editGoodsCateList = []
      this.editSelectedFenleiId = null
      this.editSort = 0
    },
    async addCateToGoods () {
      if (!this.editSelectedFenleiId) {
        this.$message.warning('请选择分类')
        return
      }
      const exist = this.editGoodsCateList.some(item => item.fenlei_id === this.editSelectedFenleiId)
      if (exist) {
        this.$message.warning('该商品已绑定此分类')
        return
      }
      this.addLoading = true
      try {
        const params = {
          goods_ids: this.editGoodsId.toString(),
          fenlei_id: this.editSelectedFenleiId,
          sort: this.editSort || 1
        }
        // if (this.editSort !== null && this.editSort !== undefined && this.editSort !== '') {
        //   params.sort = this.editSort
        // }
        const res = await request.post('/rcadmin/homeCateGoods.php?a=add', params)
        if (res && res.code === '0') {
          this.$message.success(res.msg || '添加成功')
          await this.loadGoodsCate(this.editGoodsId)
          this.fetchGoodsList()
          this.editSelectedFenleiId = null
          this.editSort = 0
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      } catch (error) {
        console.error('添加分类失败', error)
        this.$message.error('添加失败')
      } finally {
        this.addLoading = false
      }
    },
    async removeCateFromGoods (recordId) {
      try {
        await this.$confirm('确定要解绑该分类吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const params = { id: recordId }
        const res = await request.post('/rcadmin/homeCateGoods.php?a=del', params)
        if (res && res.code === '0') {
          this.$message.success(res.msg || '解绑成功')
          await this.loadGoodsCate(this.editGoodsId)
          this.fetchGoodsList()
        } else {
          this.$message.error(res.msg || '解绑失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('解绑失败', error)
          this.$message.error('解绑失败')
        }
      }
    },

    // 8. 解除绑定

    async deleteGoods (row) {
      try {
        await this.$confirm('确定要解除绑定分类关系吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // 注意：这里调用的是删除商品接口，如需单独解除分类绑定请调用接口28
        // const workId = localStorage.getItem('work_id') || ''
        // const userId = localStorage.getItem('user_id') || ''
        const ids = row.cate_goods.map(item => item.id).join(',')
        const params = { id: ids }
        await request.post('/rcadmin/homeCateGoods.php?a=del', params)
        this.$message.success('解除成功')
        this.fetchGoodsList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('解除失败', error)
          this.$message.error('解除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
/* 样式保持不变 */
.pc-container {
  height: 85vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-color: #f0f2f5;
}
.header {
  background-color: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  min-height: 64px;
  height: auto;
  flex-wrap: wrap;
  gap: 8px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.header-left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.search-input {
  width: 220px;
}
.el-main {
  flex: 1;
  padding: 0px 24px;
  overflow-y: auto;
  background-color: #fff;
}
.loading-container,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.loading-container .el-icon-loading {
  font-size: 40px;
  color: #409EFF;
  margin-bottom: 16px;
}
.empty-state p {
  color: #999;
  margin-top: 12px;
}
.el-table {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.el-icon-picture-outline {
  font-size: 32px;
  color: #ccc;
}
@media screen and (max-width: 1100px) {
  .header { padding: 8px 16px; }
  .header-right { gap: 6px 10px; }
  .search-input { width: 160px; }
}
@media screen and (max-width: 820px) {
  .header { flex-direction: column; align-items: stretch; gap: 6px; }
  .header-left { justify-content: center; }
  .header-right { justify-content: center; flex-wrap: wrap; }
  .search-input { width: 140px; }
}
</style>
